import React, {useRef, useState, useEffect } from 'react';
import {Row, Col, Card, Button, Form, Spinner, Table, Dropdown, Modal} from 'react-bootstrap';
import {listPlayers, remove, setToggleVerified} from '../../../lib/api/license';
import classNames from "classnames";
import Flex from "../../common/Flex";
import CardDropdown from "../../common/CardDropdown";
import {Add} from "./AddPlayers";
import {AddMedical} from "./Medical";
import Avatar from "../../common/Avatar";
import SubtleBadge from 'components/common/SubtleBadge';
import { useAppContext } from 'providers/AppProvider';
import {toast} from "react-toastify";
import { format, parseISO } from 'date-fns';

const formatBirthDate = value => {
  if (!value) return '';

  const date = typeof value === 'string' ? parseISO(value.slice(0, 10)) : new Date(value);
  return Number.isNaN(date.getTime()) ? '' : format(date, 'dd.MM.yy');
};

export function List({ initialData, initMode, onClose, onSave }) {
  console.log('initialData',initialData)
  const [license, setLicense] = useState(initialData);
  const [mode, setMode] = useState(initMode);
  const [players, setPlayers] = useState([]);
  const [selectedLicense, setSelectedLicense] = useState({});
  const [selectedPlayers, setSelectedPlayers] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [showModalMedical, setShowModalMedical] = useState(false);

  const {userApp} = useAppContext();

  const getPlayersList = async () => {
    const resPlayers = await listPlayers(license.document_guid);
    setPlayers(resPlayers);
  }
  useEffect(() => {
    (async () => {
      await getPlayersList();
    })();
  }, [license]);

  const handleAdd = () => {
    setSelectedLicense(license);
    setShowModal(true);
  };

  const handelDelete = async (id, name) => {
    if (confirm(`Da li ste sigurni da želite da izbrišete igrača ${name}?`)) {
        try {
            await remove(id);
            setPlayers((prev) => prev.filter((p) => p.competitions_license_guid !== id));
        }catch (err){
            toast.error(
                <span>
                    <p>Došlo je do greške.</p>
                    <p>{err.body?.message || err.message}</p>
                </span>
            );
        }
    }
  };

    const handelVerified = async (id) => {
            const _item = await setToggleVerified(id);
            setPlayers(prev =>
                prev.map(p =>
                    p.competitions_license_guid === _item.competitions_license_guid ? _item : p
                )
            );
    };

  const handelMedical = async (id) => {
      console.log('xxxx player_guid',id)
      console.log('xxxx players',players)
      const item = players.find(c => c.player_guid === id);
      console.log('item',item)
      setSelectedPlayers(item);
      setShowModalMedical(true);
  };

  const renderActions = item => (
    <CardDropdown>
      <div className="py-2">
          {!item.is_verified && (
                  <>
                    <Dropdown.Item onClick={() => handelDelete(item.competitions_license_guid, item.name + ' ' + item.last_name)}>Izbriši</Dropdown.Item>
                    <Dropdown.Divider />
                    <Dropdown.Item onClick={() => handelMedical(item.player_guid)}>Zdravstveno uvjerenje</Dropdown.Item>
                  </>
          )}

          {userApp?.role_type_id === "admin" && (
              <>
                  <Dropdown.Divider />
                  <Dropdown.Item onClick={() => handelVerified(item.competitions_license_guid)}>{item.is_verified ? 'Skloni verifikaciju' : 'Verifikovan' }</Dropdown.Item>
              </>
          )}
      </div>
    </CardDropdown>
  );

  return (
      <Card className={classNames('h-100')}>
        <Card.Header>
          <Row className={classNames('g-2')}>
            <Col>
              <Flex>
                <h5 className="mb-0 hover-actions-trigger text-truncate text-nowrap">
                  {license.club_name}
                </h5>
              </Flex>
            </Col>
            <Col xs="auto">
              {mode === 'edit' && (
                  <Button onClick={handleAdd} variant="primary">
                    Dodaj igrače
                  </Button>
              )}
            </Col>
          </Row>
        </Card.Header>
        <Card.Body className="bg-body-tertiary">
          {isLoading ? (
              <div className="text-center">
                <Spinner animation="border" role="status" />
              </div>
          ) : (
              <Row className="mb-3">
                <div className="d-none d-xl-block">
                  <Table responsive>
                    <thead>
                    <tr>
                      <th scope="col">Ime i prezime</th>
                      <th scope="col" className="text-center">Uvjerenje</th>
                      <th scope="col" className="text-center">Verifikovano</th>
                      <th className="text-end" scope="col">Akcija</th>
                    </tr>
                    </thead>
                    <tbody>
                    {players.map((item, i) => (
                        <tr key={i}>
                          <td className="text-nowrap">
                            <div className="d-flex align-items-center">
                              <Avatar src={process.env.REACT_APP_BASE_API_URL + `/uploads/${item.image_path}`} size="xl" name={item.name} />
                                <div className="ms-2">
                                  {item.name} {item.last_name}
                                  <small>{item.date_of_birth ? ` - ${formatBirthDate(item.date_of_birth)}` : ''} ({item.selection_name})</small>
                                </div>
                            </div>
                          </td>
                          <td className="text-center">
                              {item.season_medical_guid ? (
                                  <SubtleBadge pill bg='info' className='me-2'>
                                      Da
                                  </SubtleBadge>
                              ): ''}
                          </td>
                          <td className="text-center">
                              {item.is_verified ? (
                                  <SubtleBadge pill bg='success' className='me-2'>
                                      Verifikovan
                                  </SubtleBadge>
                              ): ''}
                          </td>
                          <td className="text-end">{renderActions(item)}</td>
                        </tr>
                    ))}
                    </tbody>
                  </Table>
                </div>

                <div className="d-xl-none">
                  <Row className="g-3">
                    {players.map((item, i) => (
                      <Col xs={12} key={item.competitions_license_guid || i}>
                        <div
                          className="border rounded-4 bg-white h-100 p-3 shadow-sm"
                          style={{ borderColor: '#dfe3ee' }}
                        >
                          <div className="d-flex align-items-start justify-content-between gap-3">
                            <div className="flex-shrink-0">
                              <Avatar
                                src={process.env.REACT_APP_BASE_API_URL + `/uploads/${item.image_path}`}
                                size="2xl"
                                name={item.name}
                              />
                            </div>
                            <div className="flex-shrink-0">{renderActions(item)}</div>
                          </div>

                          <div className="mt-3">
                            <div className="fw-semibold text-dark fs-8">
                              {item.name} {item.last_name}
                              <small>{item.date_of_birth ? ` - ${formatBirthDate(item.date_of_birth)}` : ''}</small>
                            </div>

                            <div className="d-flex flex-wrap gap-2 mt-2">
                              <span className="badge rounded-pill badge-subtle-primary">
                                {item.selection_name || '-'}
                              </span>
                              {item.season_medical_guid ? (
                                <span className="badge rounded-pill badge-subtle-info">Uvjerenje</span>
                              ) : null}
                              {item.is_verified ? (
                                <span className="badge rounded-pill badge-subtle-success">Verifikovan</span>
                              ) : null}
                            </div>
                          </div>
                        </div>
                      </Col>
                    ))}
                  </Row>
                </div>
              </Row>
          )}
        </Card.Body>

        <Modal show={showModal} onHide={() => setShowModal(false)} size="lg">
          <Modal.Header closeButton>
            <Modal.Title>Dodaj igrače</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {selectedLicense ? (
                <Add
                    initialData={selectedLicense}
                    onClose={() => setShowModal(false)}
                    onSave={getPlayersList}
                />
            ) : null}
          </Modal.Body>
        </Modal>

        <Modal show={showModalMedical} onHide={() => setShowModalMedical(false)} size="lg">
          <Modal.Header closeButton className="bg-200">
            <Modal.Title>Zdravstveno uvjerenje</Modal.Title>
          </Modal.Header>
          <Modal.Body className="bg-200">
              {selectedPlayers ? (
                  <AddMedical
                      player_guid={selectedPlayers.player_guid}
                      onClose={() => setShowModalMedical(false)}
                      onSave={getPlayersList}
                  />
              ) : null}
          </Modal.Body>
        </Modal>
      </Card>
  );
}
